const TechAppDownloadPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-gray-50">
      <div className="text-center max-w-md w-full mx-auto">
        <h1 className="mb-2 text-gray-900 text-2xl md:text-3xl font-bold leading-tight">Download Tech App</h1>

        <p className="mb-8 text-gray-600 text-base leading-relaxed">
          Choose your device platform to get installation instructions
        </p>

        <div className="flex flex-col gap-4">
          <button
            onClick={() => (window.location.href = '/techapp/ios')}
            className="flex items-center justify-center w-full px-6 py-4 text-lg font-bold text-white bg-[#007AFF] border-2 border-[#007AFF] rounded-lg transition-all duration-200 ease-in-out hover:bg-[#006AE6] min-h-14 cursor-pointer active:transform-none focus:outline-none focus:ring-2 focus:ring-blue-300">
            IOS Installation Guide
          </button>

          <button
            onClick={() => (window.location.href = '/techapp/android')}
            className="flex items-center justify-center w-full px-6 py-4 text-lg font-bold text-white bg-[#34A853] border-2 border-[#34A853] rounded-lg transition-all duration-200 ease-in-out hover:bg-[#2c8a43] min-h-14 cursor-pointer active:transform-none focus:outline-none focus:ring-2 focus:ring-green-300">
            Android Installation Guide
          </button>
        </div>
      </div>
    </div>
  );
};

export default TechAppDownloadPage;
